module.exports = __webpack_public_path__ + "fonts/TiemposTextWeb-Regular.a55799ce.woff";